module.exports = __webpack_public_path__ + "static/media/sample_mll_rake_schedule_vins_new.53176faa.csv";